/* @flow */
import React from 'react';
import cx from 'classnames';
import Activity from 'entities/Activity';
import ActivityDetailHeader from 'payments/components/ActivityDetailHeader.jsx';
import ActivityResponsesTableContainer from 'payments/containers/ActivityResponsesTableContainer.jsx';
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import ActivitiesActionsLayer from 'payments/components/ActivitiesActionsLayer.jsx';
import ActivityShareModal from 'payments/components/ActivityShareModal.jsx';
import ActivityEditModal from 'payments/components/ActivityEditModal.jsx';
import ActivityTransactionsModalContainer from 'payments/containers/ActivityTransactionsModalContainer.jsx';
import ActivityAddParticipantContainer from 'payments/containers/ActivityAddParticipantContainer.jsx';

import './styles/ActivityDetail.scss';

type Props = {
  activity: Activity,
  className?: ?string,
};

class ActivityDetail extends React.Component {
  props: Props;

  renderSubHeader() {
    const shareModal = <ActivityShareModal activity={this.props.activity} />;
    const editModal = <ActivityEditModal activity={this.props.activity} />;
    const transactionsModal = <ActivityTransactionsModalContainer activityID={this.props.activity.id} />;

    return (
      <div className="ActivityDetail-subheader">
        <div className="ActivityDetail-subheader-info">
          <div>
            <div className="ActivityDetail-subheader-title">
              {this.props.activity.getTitle()}
            </div>
            {this.props.activity.isClosed() &&
              <span className="ActivityDetail-closed">
                Activity is closed
              </span>
            }
          </div>
        </div>
        <div className="ActivityDetail-subheader-actions">
          {!this.props.activity.isClosed() &&
            <ActivityAddParticipantContainer activity={this.props.activity}>
              {(disabled) => {
                return (
                  <Button
                    level="secondary"
                    disabled={disabled}
                    size="xsmall">
                    Add people
                  </Button>
                );
              }}
            </ActivityAddParticipantContainer>
          }

          {!this.props.activity.isClosed() &&
            <ModalTrigger modal={shareModal}>
              <Button level="secondary" size="xsmall">
                Share
              </Button>
            </ModalTrigger>
          }

          {!this.props.activity.isClosed() &&
            <ModalTrigger modal={editModal}>
              <Button level="secondary" size="xsmall">
                Details
              </Button>
            </ModalTrigger>
          }

          {this.props.activity.isOrHasCollectedMoneyOnline() &&
            <ModalTrigger modal={transactionsModal}>
              <Button level="secondary" size="xsmall">
                Transactions
              </Button>
            </ModalTrigger>
          }

          {!this.props.activity.isClosed() &&
            <ActivitiesActionsLayer activity={this.props.activity}>
              <Button level="secondary" size="xsmall">
                <Glyph name="ellipses" solo />
              </Button>
            </ActivitiesActionsLayer>
          }
        </div>
      </div>
    );
  }

  render() {
    const { activity, className } = this.props;

    return (
      <div className={cx('ActivityDetail', className)}>
        <div className="ActivityDetail-header">
          <ActivityDetailHeader activity={activity} />
        </div>
        {
          this.renderSubHeader()
        }
        <div className="ActivityDetail-body">
          <ActivityResponsesTableContainer activity={activity} />
        </div>
      </div>
    );
  }
}

export default ActivityDetail;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityDetail.jsx